<template>
  <div class="your-msg">
    <div class="media">
      <img
        class="img-50 img-fluid m-r-20 rounded-circle"
        alt=""
        :src="getPhoto(comment.user.photo,'thumbnailCropped')"
      >
      <div class="media-body bg-white">
        <div class="d-flex justify-content-between align-items-top mb-3">
          <span class="f-w-600">
            {{ comment.user.name }} {{ comment.user.surname }} <br>
            <span class="text-primary">
              {{ comment.company.name }} {{
                getCompanyFormat(comment.company.format)
              }}
              ({{ comment.position }})
            </span>
          </span>
          <em class="text-secondary">
            {{ $t('dashboardCompany.key', {moment: getMoment(comment.logTime)}) }}
          </em>
        </div>

        <div
          v-if="comment.private"
          class="text-danger"
        >
          {{ $t('commentView.buRhGizlidir') }}
        </div>
        <div
          style="white-space: pre-wrap"
          v-html="buildPollVoteBody(comment.commentText)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {getCompanyFormat, getPhoto} from "@/repositories/Utils";
import moment from "moment";

export default {
  name: 'MyPOLVote',
  props: {
    comment: {},
  },

  methods:{
    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY HH:mm')
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    buildPollVoteBody(commentText) {

      let text = '';
      let parts = commentText.split('|');
      if (parts[0]) {
        text += '<strong>Cavab varinatı: </strong>';
        text += parts[0] + "<br>";
      }
      if (parts.length > 1 && parts[1]) {
        text += '<strong>Öz varinatım: </strong>' + parts[1];
      }

      return text;
    },
  }
}
</script>